import React from 'react';
import { LINKS, useIrA } from './Navbar';
import { contacto } from '../data/viajes';
import { img } from '../utils';
import './Footer.css';

export default function Footer() {
  const irA = useIrA();
  return (
    <footer className="footer">
      <div className="wrap footer__top">
        <div className="footer__marca">
          <span className="footer__logo"><img src={img('images/logo.png')} alt="Experiencias by Jenny" /></span>
          <p>Diseño viajes que se convierten en recuerdos para toda la vida.</p>
        </div>
        <nav className="footer__links">
          {LINKS.map((l) => <a key={l.id} href={l.ruta || `/#${l.id}`} onClick={irA(l.id)}>{l.label}</a>)}
          <a href="/#contacto" onClick={irA('contacto')}>Contacto</a>
        </nav>
      </div>
      <div className="wrap footer__bottom">
        <span>© {new Date().getFullYear()} Experiencias by Jenny · Jenny Jiménez Pons</span>
        <span>{contacto.ubicacion}</span>
      </div>
    </footer>
  );
}
